import { render, staticRenderFns } from "./error_layout_generic.vue?vue&type=template&id=1478d499&scoped=true&"
import script from "./error_layout_generic.vue?vue&type=script&lang=js&"
export * from "./error_layout_generic.vue?vue&type=script&lang=js&"
import style0 from "./error_layout_generic.vue?vue&type=style&index=0&id=1478d499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478d499",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Logo/Logo.vue').default})
